module.exports = __webpack_public_path__ + "img/fast_track_73949b5.webp";